module.exports = __webpack_public_path__ + "media/images/cc_logos/visa-7552c27fb063c67db82d5f3729080b16.png";